import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseUrl } from "../../baseUrl";
import Loader from "../../Loader";
import PropertyCard from "./PropertyCard";
import "../../Style/PropertyListing/Buyproperty.css";

// One titled section of real listings (replaces the static <BuyProperty/> placeholder).
// `request` describes how to fetch this section's listings from the existing API.
const PropertyListingSection = ({ heading, request, viewAllHref }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    axios
      .request({
        method: "post",
        url: `${baseUrl}${request.endpoint}`,
        headers: { "Content-Type": "application/json" },
        data: { page: 1, ...request.body },
      })
      .then((response) => {
        if (!active) return;
        const data = response?.data || {};
        setItems(data?.data?.propertyList || []);
        if (data?.status === "failed") setError(data?.message || "No results found.");
        setLoading(false);
      })
      .catch((err) => {
        if (!active) return;
        setError(err?.response?.data?.message || "Unable to load properties.");
        setItems([]);
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [request.endpoint, JSON.stringify(request.body)]);

  return (
    <div className="buyproperty">
      <div className="container-xxl p-0">
        <div className="heading d-flex justify-content-between align-items-center">
          <h4>{heading}</h4>
          {viewAllHref && <Link to={viewAllHref}>View All</Link>}
        </div>
        <div className="row mt-lg mt-0 gy-2">
          {loading ? (
            <Loader />
          ) : items.length > 0 ? (
            items.map((item, i) => <PropertyCard key={item.id || item.property_id || i} item={item} />)
          ) : (
            <div className="d-flex align-items-center justify-content-center py-4">
              {error || "No properties found."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyListingSection;
